<template>
    <div class="margin-header">
        <TopBar :title="$vuetify.lang.t('$vuetify.HistoryAttendance.pageName')" />
        <div class="box-round display-height">
            <div class="box-content pt-0 px-0">
                <HeaderHistory active="attendance"/>
                <div class="col-12 mt-5 pl-7 py-0 title-label mb-2 liff-line-font-size-14 line-liff-detail">
                    {{$vuetify.lang.t('$vuetify.HistoryAttendance.date.title')}}
                </div>
                <div class="px-7 liff-line-font-size-16">
                    <CustomDateRangePicker v-model="dates" @onChangeDate="onChangeDate($event)" />
                </div>
                <div class="d-flex flex-nowrap header-item  line-liff-detail">
                    <v-col cols="8" class="px-0 py-2  pl-7">
                        {{$vuetify.lang.t('$vuetify.HistoryAttendance.header.detail')}}
                    </v-col>
                    <v-col cols="4" class="px-0 py-2 text-right pr-7">
                        {{$vuetify.lang.t('$vuetify.HistoryAttendance.header.status')}}
                    </v-col>
                </div>
                <div class="font-roboto">
                  <div class="d-flex flex-nowrap list-item" v-for="(v,i) of list" :key="i">
                      <v-col cols="8" class="px-0 py-2 pl-7 text-truncate">
                          <div class="mb-1 d-flex align-center">
                              <v-icon small class="mr-3">mdi mdi-calendar</v-icon>
                              <span >{{v.date}}</span>
                          </div>
                          <div class="mb-1 text-truncate d-flex aligns-center">
                              <v-icon small class="mr-3">far fa-alarm-clock</v-icon>
                              <span>{{v.time}}</span>
                          </div>
                      </v-col>
                      <v-col cols="4" class="px-0 py-2 pr-7 text-right">{{v.status}}</v-col>
                  </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// lib
import moment from 'moment'

import HeaderHistory from './../components/HeaderHistory.vue'
import TopBar from '@/components/Liff/Components/header/TopBar.vue'
import CustomDateRangePicker from '@/components/Liff/Components/Input/CustomDateRangePicker.vue'

export default {
    name: 'HistoryAttendance',
    components: {
        TopBar,
        CustomDateRangePicker,
        HeaderHistory
    },
    data: function () {
        return {
            lineUserId: null,
            lineLiffId: process.env.VUE_APP_LINE_LIFF_HISTORY_ATTENDANCE,
            title: null,
            dates: [],
            list: []
        }
    },
    created: function () {
        this.title = 'History'
        const today = moment()
        const fromDate = today.startOf('week').format('YYYY-MM-DD')
        const toDate = today.endOf('week').format('YYYY-MM-DD')
        this.dates = [fromDate, toDate]
    },
    mounted: function () {
        this.initialData()
    },
    methods: {
        initialData: async function () {
            this.$store.dispatch('setLoading', true)
            try {
                const lineUserId = await this.$liffUtil.getLineIdForLiff(this.lineLiffId)
                this.lineUserId = lineUserId
                const params = {
                    lineId: this.lineUserId,
                    date: this.dates.map(o => o.split('-').reverse().join('/')).join('-')
                }
                const res = await this.axios.post('attendances/individual/line', params)
                if (res && res.data && res.data.status === 'ok') {
                    this.list = res.data.data
                }
            } catch {
                // do something with error
            }
            this.$store.dispatch('setLoading', false)
        },
        onChangeDate: function () {
            this.initialData()
        }
    }
}
</script>

<style lang="scss" scoped>
  @import '@/styles/color.scss';
  .header-item {
      margin-top: -5px;
      color: $base-grey2;
      background: #d9e4ed;
      font-size: 14px;
  }
  .list-item {
      padding: 5px 0;
      &:not(:last-child){
          border-bottom: 1px solid $base-grey4;
      }
      i {
          color: $base-grey;
      }
  }
</style>
